// extracted by mini-css-extract-plugin
module.exports = {"container":"nx-z","list":"ox-z"};